import React from "react";
import "./Sigueme.css";

const instagramHandle = "solecostilla.fotografia";
const instagramUrl = `https://instagram.com/${instagramHandle}`;

const Sigueme = () => (
  <section className="sigueme-wrapper" aria-labelledby="sigueme-title">
    <div className="sigueme-container">
      <h2 id="sigueme-title" className="sigueme-title">Encontrame aquí</h2>

      <a
        href={instagramUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="sigueme-link"
        aria-label={`Abrir Instagram de ${instagramHandle}`}
      >
        <span className="handle">@{instagramHandle}</span>
      </a>
    </div>
  </section>
);

export default Sigueme;